import React from 'react';
import {
  Container,
  Box,
  Typography,
  Grid
} from '@mui/material';
import Layout from '../components/Layout';
import { RecentFileActivity } from '../components/FileActivity';
import OpenTasks from '../components/OpenTasks';


const Home = () => {
  return (
    <Layout>
      <Container maxWidth="md" sx={{ marginTop: '20px', py: 3 }}>
        {/* Welcome Message */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          {/* Your welcome content here */}
        </Box>

        {/* Dashboard Sections */}
        <Grid container spacing={3}>
          {/* Recent Activity Section */}
          <Grid item xs={12} md={8}>
            <RecentFileActivity />
          </Grid>

          {/* Open Tasks Section */}
          <Grid item xs={12} md={4}>
            <OpenTasks />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Home;